export default {
  openSupport() {
    window.open(Mulligan.Brand.Support.url);
  },

  openBookshelf() {
    window.open(Mulligan.Brand.endpoint);
  }
};
